import invariant from 'invariant';

import { useEmbedSearchWidget } from '#/modules/embedSearchWidget/contexts/EmbedSearchWidgetContext';
import type { embedSearchWidgetSearchJobsRoute } from '#/modules/embedSearchWidget/jobs/routing/embedSearchWidgetJobs.routes';
import type { EmbedSearchWidgetLayoutHandleProps } from '#/modules/embedSearchWidget/layout/EmbedSearchWidgetLayoutHandleProps';
import { SearchJobsRefinements } from '#/modules/search/jobs/components/Refinements/SearchJobsRefinements';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { EmbedSearchWidgetSearchJobsPageLoadable } from './EmbedSearchWidgetSearchJobsPageLoadable';

export const handle = {
  searchRefinements: <SearchJobsRefinements />,
  darkBackground: true,
  defaultSearchType: 'JOB',
  isSearchPage: true,
  searchFromPageType: 'SEARCH',
} satisfies EmbedSearchWidgetLayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof embedSearchWidgetSearchJobsRoute>,
) {
  await EmbedSearchWidgetSearchJobsPageLoadable.load();
}

export default function EmbedSearchWidgetSearchJobsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { embedSearchWidget } = useEmbedSearchWidget();
  invariant(embedSearchWidget, 'Embed search widget not set.');

  return (
    <EmbedSearchWidgetSearchJobsPageLoadable
      embedSearchWidget={embedSearchWidget}
    />
  );
}
